export enum BaeOperationStatusEnum {
  UNKNOWN = 'UNKNOWN',
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  SUCCESS = 'PROCESSING',
  ERROR = 'ERROR',
}
